import { ErrorToast, SuccessToast } from "../components/toastify";
import convertoformdata from "../helpers/convertToFormdata";
import { AxiosPutMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const HandleEditEventInfo = async (body) => {
  body = convertoformdata(body);
  const eventUpdateRes = await AxiosPutMethod("org/events", body, false, true);
  if (eventUpdateRes.status === 200) {
    SuccessToast("Successfully Updated!");
    return true;
  } else {
    if (eventUpdateRes?.status === 401) HandleLogout();
    ErrorToast("Something went wrong on fetch event list");
    return null;
  }
};

export default HandleEditEventInfo;
